import { http } from 'utils'

// Report mutation imports.

// Report state.
const state = {}

// Report state getters.
const getters = {}

// Report actions.
const actions = {
  generateCoordinatorCommissionReport (store, payload) {
    return http.post('reports/coordinator-commission', payload)
  },

  generateCarrierIncomeReport (store, payload) {
    return http.post('reports/carrier-income', payload)
  },

  generateSystemUsersReport (store) {
    return http.post('reports/system-users')
  },

  generateMonthlyBreakdownReport (store, payload) {
    return http.post('reports/monthly-breakdown', payload)
  },

  generateCompletedJobsReport (store, payload) {
    return http.post('reports/completed-jobs', payload)
  }
}

// Report state mutations.
const mutations = {}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/report.js